/** @jsxImportSource theme-ui */

export const Menu = () => (
  <menu sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
    <a href="https://oppositewall.com" sx={{ width: '100px' }}>
      <img
        src="//cdn.shopify.com/s/files/1/2071/5523/files/OW-Logo_2020_100x.png?v=1601486624"
        srcset="//cdn.shopify.com/s/files/1/2071/5523/files/OW-Logo_2020_100x.png?v=1601486624 1x, //cdn.shopify.com/s/files/1/2071/5523/files/OW-Logo_2020_100x@2x.png?v=1601486624 2x"
        alt="Opposite Wall"
        width="100"
      />
    </a>
    <a
      href="https://oppositewall.com/collections/all-posters"
      sx={{ variant: 'links.breadcrumbs' }}
    >
      Posters
    </a>
  </menu>
)
